import { HttpContextToken } from '@angular/common/http';

// Интерцептор не показывает тост и передаёт ошибку без изменений.
// Вызывающий код сам показывает сообщение и решает, нужно ли повторить запрос.
export const HANDLE_HTTP_ERRORS_LOCALLY: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);

export const DISABLE_HTTP_ERROR_NORMALIZATION: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);
